/**
 * Keeps a Klaviyo BIS trigger in sync with the currently selected variant.
 * Looks for: [data-klaviyo-bis] inside product-form-component.
 */
// Note: Variant-change swapping is handled in `assets/product-form.js` (#onVariantUpdate).

// Initial pass (covers first render)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-form-component').forEach((pfc) => {
    if (!(pfc instanceof HTMLElement)) return;
    const isExcluded = pfc.dataset.storeExclusion === 'true';
    const productId = pfc.dataset.productId;
    // We don't have the full variant object here; rely on server-rendered "hidden" state until first update.
    const container = pfc.querySelector('[data-klaviyo-bis]');
    const trigger = container?.querySelector?.('.klaviyo-bis-trigger');
    if (trigger instanceof HTMLElement) {
      if (productId) trigger.dataset.klaviyoProductId = String(productId);
    }

    // Initial swap: if ATC is disabled on first render, hide it and show BIS.
    const atc = pfc.querySelector('add-to-cart-component[ref="addToCartButtonContainer"], add-to-cart-component');
    const atcButton = atc?.querySelector?.('button[ref="addToCartButton"]');
    if (container instanceof HTMLElement && atc instanceof HTMLElement && atcButton instanceof HTMLButtonElement) {
      if (isExcluded) {
        container.hidden = true;
        atc.hidden = false;
        return;
      }
      const disabled = atcButton.hasAttribute('disabled') || atcButton.disabled;
      container.hidden = !disabled ? true : false;
      atc.hidden = disabled;
    }
  });
});

// Note: BIS trigger is rendered as a <button type="button"> so it doesn't navigate.
